"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withPauseAndHelpLogic;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _Wrapper = _interopRequireDefault(require("../components/StyledComponents/Wrapper"));

var _LoadingContainer = _interopRequireDefault(require("../components/StyledComponents/LoadingContainer"));

var _colors = require("HubStyleTokens/colors");

var HELP_TEXT_TIMEOUT = 1000 * 5;
var PAUSE_TIMEOUT = 1000;

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withPauseAndHelpLogic(WrappedComponent) {
  var WithPauseAndHelpLogic =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(WithPauseAndHelpLogic, _React$Component);

    function WithPauseAndHelpLogic(props) {
      var _this;

      (0, _classCallCheck2.default)(this, WithPauseAndHelpLogic);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithPauseAndHelpLogic).call(this, props));
      _this.state = {
        isReady: false,
        displayHelpText: false
      };
      _this.startHelpTextTimeout = _this.startHelpTextTimeout.bind((0, _assertThisInitialized2.default)(_this));
      _this.cancelHelpTextTimeout = _this.cancelHelpTextTimeout.bind((0, _assertThisInitialized2.default)(_this));
      _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2.default)(_this));
      _this.actuallyHandlePause = _this.actuallyHandlePause.bind((0, _assertThisInitialized2.default)(_this));
      _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleReady = _this.handleReady.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleChangeVideo = _this.handleChangeVideo.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(WithPauseAndHelpLogic, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startHelpTextTimeout();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cancelTrackPauseTimeout();
        this.cancelHelpTextTimeout();
      }
    }, {
      key: "startHelpTextTimeout",
      value: function startHelpTextTimeout() {
        var _this2 = this;

        this.setState({
          displayHelpText: false
        });
        this.cancelHelpTextTimeout();
        this.displayHelpTextTimeoutId = window.setTimeout(function () {
          _this2.setState({
            displayHelpText: true
          });
        }, HELP_TEXT_TIMEOUT);
      }
    }, {
      key: "cancelHelpTextTimeout",
      value: function cancelHelpTextTimeout() {
        clearTimeout(this.displayHelpTextTimeoutId);
      }
    }, {
      key: "cancelTrackPauseTimeout",
      value: function cancelTrackPauseTimeout() {
        clearTimeout(this.trackPauseTimeout);
        this.trackPauseTimeout = false;
      }
    }, {
      key: "handlePause",
      value: function handlePause() {
        this.cancelTrackPauseTimeout();
        this.trackPauseTimeout = window.setTimeout(this.actuallyHandlePause, PAUSE_TIMEOUT);
      }
    }, {
      key: "actuallyHandlePause",
      value: function actuallyHandlePause() {
        var onPause = this.props.onPause;

        if (onPause) {
          onPause();
        }

        this.cancelTrackPauseTimeout();
      }
    }, {
      key: "handlePlay",
      value: function handlePlay() {
        var onPlay = this.props.onPlay;

        if (!this.trackPauseTimeout) {
          if (onPlay) {
            onPlay();
          }
        } else {
          this.cancelTrackPauseTimeout();
        }
      }
    }, {
      key: "handleReady",
      value: function handleReady() {
        var onReady = this.props.onReady;
        this.setState({
          isReady: true
        });

        if (onReady) {
          onReady();
        }
      }
    }, {
      key: "handleChangeVideo",
      value: function handleChangeVideo() {
        this.setState({
          isReady: false
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            displayHelpText = _this$state.displayHelpText,
            isReady = _this$state.isReady;
        var _this$props = this.props,
            onPlay = _this$props.onPlay,
            onPause = _this$props.onPause,
            onReady = _this$props.onReady,
            loadingBackground = _this$props.loadingBackground,
            placeholderAspectRatio = _this$props.placeholderAspectRatio,
            passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["onPlay", "onPause", "onReady", "loadingBackground", "placeholderAspectRatio"]);
        return _react.default.createElement(_Wrapper.default, {
          isReady: isReady,
          placeholderAspectRatio: placeholderAspectRatio,
          loadingBackground: loadingBackground
        }, _react.default.createElement(_LoadingContainer.default, {
          displayHelpText: displayHelpText
        }), _react.default.createElement(WrappedComponent, (0, _extends2.default)({
          startHelpTextTimeout: this.startHelpTextTimeout,
          cancelHelpTextTimeout: this.cancelHelpTextTimeout,
          onPause: this.handlePause,
          onPlay: this.handlePlay,
          onReady: this.handleReady,
          onChangeVideo: this.handleChangeVideo
        }, passThroughProps)));
      }
    }]);
    return WithPauseAndHelpLogic;
  }(_react.default.Component);

  WithPauseAndHelpLogic.defaultProps = {
    videoPlaySpeed: 100,
    loadingBackground: _colors.OLAF,
    color: _colors.LORAX,
    placeholderAspectRatio: 16 / 9
  };
  WithPauseAndHelpLogic.displayName = "WithPauseAndHelpLogic(" + getDisplayName(WrappedComponent) + ")";
  return WithPauseAndHelpLogic;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-video-player/static-1.2019/js/higherOrderComponents/withPauseAndHelpLogic.js
// module id = 275
// module chunks = 0